function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconQr = function SvgIconQr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M9.5 11V9h2v2h-2ZM9.5 15v-2h2v2h-2ZM13.5 11V9h2v2h-2ZM13.5 15v-2h2v2h-2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M9.5 11V9h2v2h-2ZM9.5 15v-2h2v2h-2ZM13.5 11V9h2v2h-2ZM13.5 15v-2h2v2h-2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M3.5 10V3h7M15 3h6.5v7m-18 4.5V21h6m6 0h6v-6.5"
  }));
};
export default SvgIconQr;